import { render, staticRenderFns } from "./Archived.vue?vue&type=template&id=069d5016&"
import script from "./Archived.vue?vue&type=script&lang=ts&"
export * from "./Archived.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports